import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'ContactBookSite';
  loginLabel: string = "Login";
  logoutLabel = "Logout";
  signInLabel = "Cadastrar usuário"
}
